"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=tail.js.map